import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled Components
import { SmartContainer, Stack, HorizontalStack } from '../../styles/Containers';
import { StyledChip } from '../../styles/matieralui/Chip';
import { splitAndTrim } from '../../services/Utils';

// Components
import { Autocomplete } from '../Forms/Autocomplete';
import { StyledB, StyledP } from '../../styles/StyledHTML';

const StyledChipInline = styled(StyledChip)`
    margin-bottom: 1em !important;
`




export const TagSelector = ({ helperText = null, noLabels = false, inputLabel = "search", label, helper = null, options, existingOptions, selector, action, onChange, limit = null, renderOption }) => {


    // ------------------------------
    // State
    // ------------------------------

    const [activeTags, setActiveTags] = useState([])
    const newTag = ''
    const [value, setValue] = useState('');
    const [tagsLoaded, setTagsLoaded] = useState(false);
    const [loaded, setLoaded] = useState(false);


    // ------------------------------
    // Effects
    // ------------------------------

    useEffect(() => {
        if (existingOptions && loaded !== true && options) {
            setLoaded(true);
            const active = tagDifferenceById(existingOptions);
            setActiveTags(active);
        }
    }, [existingOptions, options])

    // Save Tags
    useEffect(() => {


        // Save Tag Changes
        if (onChange) {
            if (loaded) {
                onChange(activeTags)
            }
        }

    }, [activeTags])

    // ------------------------------
    // Methods
    // ------------------------------

    const handleRemoveTag = (tag) => {
        if (!tag) return;
        const tags = activeTags.filter(theTag => tag.name !== theTag.name);
        setActiveTags([...tags])
    }

    const handleAddTag = (tag) => {

        if (!tag) {
            return;
        }
        if (!loaded) {
            setLoaded(true); // Just added for onboarding. Remove if causing problems.
        }
        const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
        if (!exists) setActiveTagsFormat([...activeTags, tag])
    }
    const setActiveTagsFormat = (arr) => {

        // Make Sure There Are No Duplicates
        const storage = []
        const filtered = arr.filter(item => {
            if (!storage.includes(String(item.name).toLowerCase())) {
                storage.push(String(item.name).toLowerCase())
                return item;
            }
            return false;

        })
        setActiveTags(filtered)
    }

    const tagDifferenceById = (arr) => {
        if (!options) return [];
        const tags = options.filter(tag => {
            const exists = arr.filter(theTag => tag.id === theTag.id).length;
            return exists;
        })
        return tags;
    }

    const tagDifference = () => {
        if (!options) return [];
        const tags = options.filter(tag => {
            const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
            return !exists;
        })
        return tags;
    }


    const handleNewTag = (name) => {

        // Guard: Empty Album Name
        if (name?.length <= 0) return;

        if (name.indexOf(',') > -1) {
            const formatted = splitAndTrim(name, ',').map(item => { return { name: item }; })
            setActiveTagsFormat([...activeTags, ...formatted]);
        } else {
            handleAddTag({ name }) // Single Value
            // Clear value
            setValue('')

        }

    }

    const onEnter = (v) => {

        handleNewTag(v);
    }


    // ------------------------------
    // Render
    // ------------------------------

    const renderTags = (tags) => {
        if (!tags) return (<div></div>)
        return tags.map(tag => (
            <StyledChipInline key={tag.id} label={tag.name} clickable onDelete={() => handleRemoveTag(tag)} />
        ))
    }

    const renderAutoComplete = (opts) => {
        // if (!opts) return null;
        if (limit !== null && activeTags?.length >= limit) return null;
        return (
            <Autocomplete
                width="100%"
                label={inputLabel}
                options={tagDifference()}
                optionLabelKey="name"
                onChange={handleAddTag}
                value={value}
                type="text"
                noOptionsTextAction={handleNewTag}
                noOptionsText="Add New"
                onEnter={onEnter}
                helperText={helperText}
                renderOption={renderOption}
            />
        )
    }

    return (
        <SmartContainer width="100%">

            <SmartContainer width="100%">
                {!noLabels && (
                    <SmartContainer>
                        <StyledP><StyledB>{label}</StyledB></StyledP>
                        {helper && (<StyledP light>{helper}</StyledP>)}
                    </SmartContainer>
                )}


                <HorizontalStack width="100%">{renderTags(activeTags)}</HorizontalStack>

                {renderAutoComplete(options)}
            </SmartContainer>
        </SmartContainer>
    )
}